import en from './en';
import es from './es';
import id from './id';

export const messages = {
  en,
  es,
  id
};
